<template>
  <div>
    <nav-header  />

  <div class="query-order">

    <div class="query-header">
      <h2>订单查询</h2>
      <p class="tip-text">为防止信息被恶意窃取，仅可以查询支付后有效期内的订单。</p>
    </div>

    <div class="query-form">
      <el-input
        v-model="orderNo"
        placeholder="请输入订单号"
        clearable
        class="order-input"
      >
        <template #append>
          <el-button 
            type="primary" 
            @click="queryOrder" 
            :loading="loading"
            class="query-btn"
          >
            查询
          </el-button>
        </template>
      </el-input>
    </div>

    <!-- 订单详情 -->
    <el-card v-if="orderInfo" class="order-detail">
      <div class="order-status">
        <el-tag :type="orderInfo.status === '交易成功' ? 'success' : 'info'">
          {{ orderInfo.status }}
        </el-tag>
      </div>

      <el-descriptions :column="1" border>
        <el-descriptions-item label="支付方式">
          {{ orderInfo.payType }}
        </el-descriptions-item>
        <el-descriptions-item label="商品">
          {{ orderInfo.productName }}
        </el-descriptions-item>
        <el-descriptions-item label="订单金额">
          ¥ {{ orderInfo.amount }}
        </el-descriptions-item>
        <el-descriptions-item label="支付时间">
          {{ orderInfo.payTime }}
        </el-descriptions-item>
        <el-descriptions-item label="交易号">
          {{ orderInfo.transactionId }}
        </el-descriptions-item>
        <el-descriptions-item label="商户订单号">
          {{ orderInfo.merchantOrderNo }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 帮助信息 -->
    <div class="help-section">
      <div class="help-title" @click="showHelp = !showHelp">
        <span>订单号在哪里？</span>
      </div>

      <div v-if="showHelp" class="help-content">
        <el-row :gutter="20">
          <!-- 支付宝指引 -->
          <el-col :span="12">
            <div class="help-item">
              <div class="help-header">
                <h4>支付宝</h4>
                <p>我的->账单->账单详情</p>
              </div>
              <div class="help-images">
                <el-image 
                  src="https://www.klgeek.com/image/alidanhao2.png"
                  :preview-src-list="['https://www.klgeek.com/image/alidanhao2.png']"
                  fit="cover"
                  class="guide-img"
                >
                  <template #error>
                    <div class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </template>
                </el-image>
              </div>
            </div>
          </el-col>
          
          <!-- 微信指引 -->
          <el-col :span="12">
            <div class="help-item">
              <div class="help-header">
                <h4>微信</h4>
                <p>钱包->支付中心（右上角）->账单</p>
              </div>
              <div class="help-images">
                <el-image 
                  src="https://www.klgeek.com/image/weixin.png"
                  :preview-src-list="['https://www.klgeek.com/image/weixin.png']"
                  fit="cover"
                  class="guide-img"
                >
                  <template #error>
                    <div class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </template>
                </el-image>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import NavHeader from "@/components/layout/NavHeader.vue";

const isMobileDevice=() =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检查用户代理字符串
  return /android|iPhone|iPad|iPod|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);
}
export default {
  name: 'QueryOrder',
  components: {NavHeader},
  data() {
    return {
      orderNo: '',
      loading: false,
      showHelp: false,
      orderInfo: null
    }
  },
  methods: {
    async queryOrder() {
      if (!this.orderNo.trim()) {
        this.$message.warning('请输入订单号')
        return
      }
      
      this.loading = true
      try {
        const res = await this.$http2({
          url: `/pay/getConent?mchOrderNo=${this.orderNo}`,
          method: 'get'
        })
        if(!res.data)  this.$message.error('查询失败：作品不存在或已被删除' )
        if(isMobileDevice()){
          if(res.data.name){  //卡密
            location.href=process.env.VUE_APP_SHARE_BASE+"/h5/#/pages/creation/faka-detail?mchOrderNo="+this.orderNo;
          }else {
            location.href=process.env.VUE_APP_SHARE_BASE+"/h5/#/pages/creation/detail?mchOrderNo="+this.orderNo;
          }

        }else{
          if(res.data.name){  //卡密
            this.$router.push("/fakaDetail/"+res.data.id+"?mchOrderNo="+this.orderNo)
          }else{
            this.$router.push("/creation/"+res.data.id+"?mchOrderNo="+this.orderNo)
          }
        }
      } catch (error) {
        // this.$message.error('查询失败：' + error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.query-order {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.query-header {
  text-align: center;
  margin-bottom: 30px;
  
  h2 {
    font-size: 24px;
    color: #303133;
    margin-bottom: 12px;
  }
  
  .tip-text {
    color: #909399;
    font-size: 14px;
  }
}

.query-form {
  margin-bottom: 30px;
  
  .order-input {
    :deep(.el-input-group__append) {
      padding: 0;
      background-color: var(--el-button-bg-color);
      
      .query-btn {
        margin: 0;
        border: none;
        height: 40px;
        padding: 0 20px;
        border-radius: 0 4px 4px 0;
      }
    }
  }
}

// 确保按钮在输入框内正确显示
:deep(.el-input-group__append .el-button) {
  border: 0;
  height: 100%;
}

// 确保按钮颜色正确
:deep(.el-button--primary) {
  --el-button-bg-color: var(--el-color-primary);
  --el-button-border-color: var(--el-color-primary);
  --el-button-hover-bg-color: var(--el-color-primary-light-3);
  --el-button-hover-border-color: var(--el-color-primary-light-3);
  color: var(--el-color-white);
}

.order-detail {
  margin-bottom: 30px;
  
  .order-status {
    text-align: center;
    margin-bottom: 20px;
    
    .el-tag {
      font-size: 16px;
      padding: 8px 16px;
    }
  }
}

.help-section {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 16px;
  
  .help-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    
    span {
      color: #606266;
      font-size: 14px;
    }
  }
  
  .help-content {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
    
    .help-item {
      background: #fff;
      border-radius: 8px;
      padding: 16px;
      height: 100%;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
      
      .help-header {
        text-align: center;
        margin-bottom: 16px;
        
        h4 {
          color: #303133;
          margin: 0 0 8px;
          font-size: 16px;
          font-weight: 600;
        }
        
        p {
          color: #606266;
          margin: 0;
          font-size: 14px;
        }
      }
    }

    .help-images {
      display: flex;
      justify-content: center;
      
      .guide-img {
       
        border-radius: 8px;
        border: 1px solid #ebeef5;
        overflow: hidden;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
      
      .image-slot {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #f5f7fa;
        color: #909399;
        font-size: 24px;
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 768px) {
  .query-order {
    padding: 16px;
    width: 100%;
  }
  
  .query-header {
    h2 {
      font-size: 20px;
    }
  }
  
  .help-section {
    margin-top: 20px;
  }

  .help-content {
    .el-row {
      margin: 0 !important;
    }
    
    .el-col {
      padding: 0 !important;
      margin-bottom: 16px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    .help-item {
      padding: 12px;
    }
    
    .help-images {
      .guide-img {
        width: 150px;
        height: 270px;
      }
    }
  }
}
</style>

